import { ProductSearchMaterial } from '../../types';

export function getIsPaintProductType(material: ProductSearchMaterial) {
  return material.isPaint;
}

export function getIsProductFinishType(material: ProductSearchMaterial) {
  return material.isFinish;
}
